import { render, staticRenderFns } from "./EmployeeVerticalHeader.vue?vue&type=template&id=1c22e4ee&scoped=true&"
import script from "./EmployeeVerticalHeader.vue?vue&type=script&lang=js&"
export * from "./EmployeeVerticalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c22e4ee",
  null
  
)

export default component.exports